<script setup lang="ts">
import { MMText } from '@mm-frontend/mm-web-ui-kit';

defineProps<{ max: number }>();
</script>

<template>
  <MMText font="Body M/Regular" color="inverse-primary" class="counter-tooltip">
    В наличии только {{ max }} шт.
  </MMText>
</template>

<style scoped lang="stylus">
.counter-tooltip
  padding 8px
  border-radius 12px
  background-color #1f2026
</style>
